export default __webpack_public_path__ + "static/media/X_Xaina.607f0103.mp3";